import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpendinginline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		children: [/* @__PURE__ */ _jsx("path", {
			strokeWidth: 1.125,
			d: "m2.402 15.838 1.991-9a.75.75 0 0 1 .732-.588h8.15a.75.75 0 0 1 .732.588l1.99 9a.75.75 0 0 1-.731.912H3.134a.75.75 0 0 1-.732-.912",
			clipRule: "evenodd"
		}), /* @__PURE__ */ _jsx("path", {
			strokeWidth: 1.125,
			d: "M7.325 6.25V4.375c0-1.036.84-1.875 1.875-1.875h0c1.037 0 1.876.84 1.876 1.875V6.25M4.58 6.505 6.845 16.75"
		})]
	})
});
export default SvgSpendinginline;
